import React from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useState } from "react";
import useTranslate from "src/hooks/use-translate";

import "./rich-text-editor.style.scss";

const RichTextEditor = ({ dismiss = () => {}, save = () => {} }) => {
	const [text, setText] = useState("");

	const t = useTranslate("RichTextEditor");

	const config = {
		plugins: ClassicEditor.builtinPlugins,
		// toolbar: ClassicEditor.defaultConfig.toolbar.items,
		toolbar: [
			"heading",
			"|",
			"bold",
			"italic",
			"|",
			"outdent",
			"indent",
			"|",
			"bulletedList",
			"numberedList",
			"|",
			"undo",
			"redo",
		],
	};

	const handleSubmit = () => {
		save(text);
	};

	return (
		<div className="rich-text-editor-container">
			<div className="editor border--left border--thicker border--red">
				<CKEditor
					editor={ClassicEditor}
					data={text}
					config={config}
					onChange={(event, editor) => {
						const data = editor.getData();
						setText(data);
					}}
				/>
			</div>
			<div className="flex flex--end-content gap-xl margin-m--top">
				<button onClick={dismiss} className="w500 btn padding-s--block padding-xxxxxxl--inline">
					{t("Cancel")}
				</button>
				<button
					onClick={handleSubmit}
					className="w500 smooth-corners padding-s--block padding-xxxxxxl--inline"
					style={{ backgroundColor: "#DA676C", color: "white" }}
				>
					{t("Submit")}
				</button>
			</div>
		</div>
	);
};

export default RichTextEditor;
